module.exports = __webpack_public_path__ + "img/cls-sport-sedan.e9d12d8a.jpg";